import './BeatRow.css';

interface BeatRowProps {
  count: number;
  /** 0-based active beat, or -1 for none. */
  active: number;
  bpm: number;
  /** Labels override the default 1..n — used by the strumming grid. */
  labels?: readonly string[];
}

/**
 * The beat counter.
 *
 * The pulse duration is bound to the tempo (60/BPM) rather than to a fixed
 * animation time: the beat is music, and a highlight that outlives its beat
 * teaches the player the wrong thing. Under `prefers-reduced-motion` the scale
 * animation drops out and only the colour changes — the count stays legible.
 */
export function BeatRow({ count, active, bpm, labels }: BeatRowProps) {
  const beatDuration = 60 / Math.max(1, bpm);

  return (
    <div className="beat-row" role="group" aria-label={`${bpm} BPM`}>
      {Array.from({ length: count }, (_, index) => {
        const isActive = index === active;
        return (
          <span
            key={index}
            className={`beat-row__dot${isActive ? ' beat-row__dot--active' : ''}`}
            style={isActive ? { animationDuration: `${beatDuration}s` } : undefined}
            aria-hidden="true"
          >
            {labels ? labels[index] : index + 1}
          </span>
        );
      })}
    </div>
  );
}
